import user from './user'
import shop from './shop'
import order from './order'
import courier from './courier'
import payment from './payment'
import agent from './agent'
import invoice from './invoice'
import log from './log'
import seller from './seller'
import dashboard from './dashboard'
import cms from './cms'
import caseTracking from './caseTracking'
import fbLiveConnect from './fbLiveConnect'
import subscription from './subscription'
import userManagement from './userManagement'
import permission from './permission'
import document from './document'
import overview from './overview'

export default {
    user,
    shop,
    order,
    courier,
    payment,
    agent,
    invoice,
    log,
    seller,
    dashboard,
    cms,
    caseTracking,
    fbLiveConnect,
    subscription,
    permission,
    userManagement,
    document,
    overview
}
